import { blue } from "@material-ui/core/colors";

export const constants = {
  tabLabelModel: "Models",
  tabLabelDD: "Data Descriptions",
  tabLabelView: "Views",
  tabLabelDrawings: "Drawings",
  tabLabelMsgConfig: "Configure Messages",
  newModelBtnLabel: "New Model",
  cancelBtnLabel: "Cancel",
  createBtnLabel: "Create",
  deleteBtnLabel: "Delete",
  yesBtnLable: "Yes",
  dontSaveBtnLabel: "Don't Save",
  saveAndCopyBtnLabel: "Save and Copy",
  showingTableLabel: "Showing",
  sortByLabel: "sort by",
  searchPlacholder: "Search",

  createNewModel: "Create a New Model",
  modelNameLabel: "Model Name",
  modelRegionLabel: "Region",
  isActiveLabel: "Is Active",
  editDdNname: "Edit DdNames",
  editviews: "Edit Views",
  editDrawings: "Edit Drawings",

  editBlockInformation: "Edit Block Information",
  seeVersionHistory: "See Version History",
  regionNameLabel: "Region Name",
  versionLabel: "Version",
  statusLabel: "Status",
  information: "Information",
  blockInformationSubtitle: "Add info to be directly displayed on the drawing",
  files: "Files",
  blockInformationLabel: " Block Information",
  infoLabelField: "Info Label",
  ddNameField: "dd Name",
  dxfNameField: "dxf Name",

  retriveModelError: "Error while retrieving Models",
  modelExistError: "Model Name already exists",
  modelNameUpdate: "Model name updated",
  newModelCreateSucess: "Created new model",
  createModelError: "Error while creating a new model",
  modelDeleteSuccess: "has been deleted.",
  modelDeleteError: "Error while deleting model",
  modelupdateSuccess: "has been updated",
  modelupdateError: "Error while updating model",
  modelRegionError: "Model Region already exists",
  modelRegionUpdate: "Region name updated",
  sortingError: "`Error while Sorting Data",
  modelDeleteWarning:
    "All related Data descriptions, Views and Drawings of this model will be deleted.",
  modelDeleteTitle: "Are you sure want to delete?",
  unsaveWarningTitle: "Warning",
  unsaveWarningContent:
    "You have unsaved changes, On close you will loose all your changes. Are you sure you want to close?",
  uploadFileError: "Error while uploading the file.",
  changesSaveSuccess: "Changes were saved successfully",
  replacebleTextSaveError:
    "Something went wrong while saving replaceable texts",
  blockInformationCopySuccess: "Block information copied successfully",
  blockInformationCopyError: "Error while copy block information",
  unsavedChangesWarningText:
    'You have unsaved changes, Please press "Save and Copy" to save your changes, or "Don\'t Save" to copy the information without saving.',

  columnTypeLabel: "Column Type",
  addNewConfigGroupPlaceholder: "Add New Config Group",
  createNewDDTitle: "Create a New Data Description",
  DDNameLabel: "Data Descrption Name",
  DDDescriptionLabel: "Data Descrption Description",
  configGroupLabel: " Config group name",
  configGroupTitle: "Config group",
  refreshData: "Refreshing data",
  dataNotFound: "No Data Found",
  newDDName: "New DdName",
  ddNameHeadLabel: "DdName (key)",
  descHeadLabel: "Description",
  configGrpHeadLabel: "Config Group",
  clmTypeHeadLabel: "Column Type",
  isVisible: "Is Visible",
  valueHeadLabel: "Values",

  deleteDDWarningContent:
    "All related information regarding this Data description will be deleted.",
  DDAlreadyExistError: "DD Name already exists",
  createNewDDSuccess: "Created new DD",
  createDDError: "Error while creating a new DD",
  updateDDError: "Error while updating DD",
  ddAlreadyExistError: "DD name already exist with same group",
  drawingDeleteError: "Error while deleting drawing",
  configAlreadyExistError: "Config Name already exists",
  reorderError: "Error while reordering view",
  ddDeleteSuccess: "data description deleted",
  configGroupUpdate: "Config group updated",
  ddUpdateSuccess: "Updated Successfully",
  retriveDDError: "Error while retrieving Data Descriptions",
  sortDataSuccess: "Sorted Data Successfully",

  viewNameFieldLabel: "View Name",
  isVisible: "Is Visible",
  newViewBtnLabel: "New View",
  pageSize: "Page Size",

  viewDeleteError: "Error while deleting view",
  deleteViewWarningContent:
    "All related information regarding this View will be deleted.",
  viewAlreadyExistError: "View Name already exists",
  updateViewSucess: "Updated View",
  updateViewError: "Error while updating model",
  createViewSuccess: "Created new View",
  createViewError: "Error while creating a new View",
  retriveViewError: "Error while retrieving Views",
  createNewView: "Create a New View",

  drawingName: "Drawing Name",
  viewName: "View",
  pageNumber: "Page Number",
  pageLabel: "Page Label",
  pageDescription: "Page Description",
  uploadDrawing: "Upload Drawing",
  addNewRecord: "Add New Record",
  uploadDrawings: "Upload Drawings",

  drawingAlreadyExist: "Drawing Name already exists",
  updateDrawingView: "Updated drawing view",
  drawingNameError: "Error while updating name",
  updateDrawingError: "Error while updating drawing view",
  updateDrawingName: "Updated drawing name to",
  pageNoError: "Page number should be a number",
  pageInfoUpdated: "Page info updated",
  pageInfoError: "Error while updating page info",
  drawingDeleteSuccess: "Drawing deleted successfully",
  drawingUploadError: "Error uploading the file.",
  uploadFilemodelIdError:
    "Error uploading the file as the model ID was not found in S3",
  drawingUploadSuccess: "Drawings uploaded successfully",
  validDXFerror: "Please upload valid dxf file",
  recordAddedSuccess: "Record added successfully",
  recordAddedError: "Error: could not add the record",

  saveBtnLabel: "Save",
  removeBtn: "Remove",
  removeAllBtn: "Remove All",
  addRecord: "Add Record",
  selectDrawing: "Select Drawing",
  selectView: "Select View",

  addMoreDrawingLabel: "Add More Drawings",
  selectDrawingToUpload: "Select Drawings to Upload",
  selectDXFOnly: "Select .dxf files only",
  dxfFileError: "Only .dxf files are allowed to upload.",

  newRuleBtn: "New Rule",
  DNameText: "DD Name",
  max: "Max",
  min: "min",
  newRuleSetBtn: "New Rule Set",
  rulesText: "Rules",
  layersText: "Layers",
  detectedLabel: "Detected",
  obseleteLabel: "Obselete",
  layerNameLabel: "Layer Name",
  alwaysOnLabel: "Always ON",
  removeForDXFLabel: "Remove for DXF",
  isCompareFullnameLabel: "isCompare Fullname",
  alwaysOffLabel: "Always Off",

  copyFromAnotherDrawing: "Copy from another drawing",
  deleteConfirmText: "Are you sure you want to delete",
  saveSuccess: "Saved successfully",
  somethingWentWrong: "Something went wrong while saving data",
  deleteConfirmTitle: "Delete Confirmation",

  adminLabel: "Admin",

  searchForView: "Search for a View",
  selectAView: "Select a View",
  noOptionFound: "No option found",

  drawingAlreadyExist: "Drawing Name already exists",
  updateDrawingView: "Updated drawing view",
  drawingNameError: "Error while updating name",
  updateDrawingError: "Error while updating drawing view",
  updateDrawingName: "Updated drawing name to",
  pageNoError: "Page number should be a number",
  pageInfoUpdated: "Page info updated",
  pageInfoError: "Error while updating page info",
  drawingDeleteSuccess: "Drawing deleted successfully",
  drawingUploadError: "Error uploading the file.",
  uploadFilemodelIdError:
    "Error uploading the file as the model ID was not found in S3",
  drawingUploadSuccess: "Drawings uploaded successfully",
  validDXFerror: "Please upload valid dxf file",
  recordAddedSuccess: "Record added successfully",
  recordAddedError: "Error: could not add the record",

  saveBtnLabel: "Save",
  removeBtn: "Remove",
  removeAllBtn: "Remove All",
  addRecord: "Add Record",
  selectDrawing: "Select Drawing",
  selectView: "Select View",

  addMoreDrawingLabel: "Add More Drawings",
  selectDrawingToUpload: "Select Drawings to Upload",
  selectDXFOnly: "Select .dxf files only",
  dxfFileError: "Only .dxf files are allowed to upload.",

  newRuleBtn: "New Rule",
  DNameText: "DD Name",
  max: "Max",
  min: "min",
  newRuleSetBtn: "New Rule Set",
  rulesText: "Rules",
  layersText: "Layers",
  detectedLabel: "Detected",
  obseleteLabel: "Obselete",
  layerNameLabel: "Layer Name",
  alwaysOnLabel: "Always ON",
  removeForDXFLabel: "Remove for DXF",
  isCompareFullnameLabel: "isCompare Fullname",
  alwaysOffLabel: "Always Off",

  copyFromAnotherDrawing: "Copy from another drawing",
  deleteConfirmText: "Are you sure you want to delete",
  saveSuccess: "Saved successfully",
  somethingWentWrong: "Something went wrong while saving data",
  deleteConfirmTitle: "Delete Confirmation",

  adminLabel: "Admin",

  searchForView: "Search for a View",
  selectAView: "Select a View",
  noOptionFound: "No option found",

  enterNewValuePlacholder: "Enter new values (separate with commas)",

  revertModelError: "Revert model version failed",
  modelDraftError: "Model status in draft, we cannot edit this model",

  modelRestoreTitle: "Restore Old Model Version",
  modelRestoreWarningOne:
    "Restore is not possible because you are currently in draft status",
  modelRestoreWarningTwo:
    "Cannot restore the draft model in Published mode. Please click on edit and restore the changes.",
  modelRestoreWarningThree: "This restore will delete the draft version of",
  modelRestoreWarningFour:
    "Cannot restore as the model is in Modified mode. Please save and cancel the ongoing modification",
  restoreBtn: "Restore",
  okayBtn: "Okay",
  deletModelVersionTitle: "Delete Model Version",
  deleteModelVersionWarning:
    "Are you sure you want to delete this model version?, this action cannot be undo...!",

  "Publish New Version": "Publish New Version",
  Model: "Model",
  Version: "Version",
  "New version description": "New version description",
  publishWarning: "This version will replace current live version",
  publish: "Publish",
  saveDraftWarning:
    "This will overwrite the existing saved archive. Do you want to continue?",
  "Save Changes": "Save Changes",
  Revert: "Revert",
  revertWarning: "On revert all changes will be reverted",
  "Revert All Changes": "Revert All Changes",

  ecatRuleImportBtn: "Import from ECAT Rules",
  merge: "Merge",
  productLine: "Product Line",
  ruleset: "Ruleset",
  tag: "Tag",
  properties: "Properties",
  enviroment: "Enviroment",

  exportData: "Export Data",

  newMsgBtn: "New Message",
  modelRegionTitle: "Region update confirmation",
  modelRegionUpateMsg: "Are you sure you want to upate the region of the model",
  deleteConfigMsgWarningContent:
    "All related information regarding this configure message will be deleted.",
  errorFetchConfigMsgList: "Error while fetching configure message list",
  msgDeleteSuccess: "Configure message has been deleted successfully",
  msgDeleteError: "Delete configure message has been failed",
  noMsgData: "No Configure messages to show",
  msgUpdateSuccess: "Configure message has been updated successfully",
  msgCreateSuccess: "Configure message has been created successfully",
  editConfigMsg: "Edit Configure Messages",
  Success: "Success",
  Warning: "Warning",
  Info: "Info",
  Error: "Error",
  "Message Name": "Message Name",
  "Message Type": "Message Type",
  Message: "Message",
  "Create New Message": "Create New Message",
  Paste: "Paste",
  "Copy All": "Copy All",
  validationErrorRules: "ddName, Min and Max values are required, please select approriate value for it"
};
